let certificationsList=[
    {
        title:"Supervised Machine Learning",
        instructor:"DeepLearning.AI - Stanford University",
        link:"https://www.coursera.org/account/accomplishments/certificate/RD8SJDCQEVEL",
        platform:'Coursera'
    },
    {
        title:"Problem Solving (Basic)",
        instructor:"HackerRank",
        link:"https://www.hackerrank.com/certificates/c39877eb7589",
        platform:'HackerRank'
    },
    {
        title:"Advanced Styling with Responsive design",
        instructor:"University of Michigan",
        link:"https://www.coursera.org/account/accomplishments/certificate/LLBYDL9VP37H",
        platform:'Coursera'
    },
    // {
    //     title:"Getting Started with Python",
    //     instructor:"University of Michigan",
    //     link:"https://www.coursera.org/account/accomplishments/certificate/ZVBB977SJD3M",
    //     platform:'Coursera'
    // },
    {
        title:"Python data Structures",
        instructor:"University of Michigan",
        link:"https://www.coursera.org/account/accomplishments/certificate/RZZDKTN84NX4",
        platform:'Coursera'
    },
    {
        title:"Using Python to access web data",
        instructor:"University of Michigan",
        link:"https://www.coursera.org/account/accomplishments/certificate/NY2A2DM7RJUM",
        platform:'Coursera'
    },
    // {
    //     title:"Using Databases with Python",
    //     instructor:"University of Michigan",
    //     link:"https://www.coursera.org/account/accomplishments/certificate/NY2A2DM7RJUM",
    //     platform:'Coursera'
    // },
    // {
    //     title:"Introduction to HTML5",
    //     instructor:"University of Michigan",
    //     link:"https://www.coursera.org/account/accomplishments/certificate/R22TE4AF5R2B",
    //     platform:'Coursera'
    // },
    // {
    //     title:"Introduction to CSS3",
    //     instructor:"University of Michigan",
    //     link:"https://www.coursera.org/account/accomplishments/certificate/DW33N72UFYMH",
    //     platform:'Coursera'
    // },
    {
        title:"Interactive with Javascript",
        instructor:"University of Michigan",
        link:"https://www.coursera.org/account/accomplishments/certificate/95FWNTPV5CB6",
        platform:'Coursera'
    },
    
];

const CertificatesData={certificationsList};
export default CertificatesData;